<template>
  <div>
    <v-card>
      <v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn flat color="red" @click="backToImageUploader()">{{
            $t("btn_cancel")
          }}</v-btn>
          <v-btn @click="cropImage" color="primary" class="black--text">{{
            $t("btn_crop")
          }}</v-btn>
        </v-card-actions>
        <v-layout row wrap>
          <v-flex xs12 class="text-xs-center">
            <div
              :style="{
                width: height * 1.3 + 'px',
                height: height,
                border: '1px solid gray',
                display: 'inline-block',
              }"
            >
              <vue-cropper
                :aspectRatio="aspectRatio"
                ref="cropper"
                :cropBoxResizable="cropBoxResizable"
                :guides="guides"
                :view-mode="viewMode"
                :drag-mode="dragMode"
                :auto-crop-area="autoCropArea"
                :min-container-width="height * 1.3"
                :min-container-height="height"
                :background="background"
                :rotatable="rotatable"
                :src="imgSrc"
                alt="Source Image"
                :img-style="{ width: height * 1.3 + 'px', height: height }"
                v-if="imgSrc != ''"
              ></vue-cropper>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="mb-3">
          <v-flex xs4 sm4></v-flex>
          <v-flex xs2 sm2>
            <!-- <label style="font-size:17px;top:15px;color:#333333;">Image name :</label> -->
          </v-flex>
          <v-flex xs6 sm6>
            <label style="font-size: 17px; top: 15px; color: #616a6b">{{
              imageName
            }}</label>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
export default {
  props: {
    imageName: {
      type: String,
      default() {
        return "image_name";
      },
    },
    aspectRatio: {
      type: Number,
      default() {
        return 16 / 9;
      },
    },
    cropBoxResizable: {
      type: Boolean,
      default() {
        return true;
      },
    },
    guides: {
      type: Boolean,
      default() {
        return true;
      },
    },
    viewMode: {
      type: Number,
      default() {
        return 2;
      },
    },
    dragMode: {
      type: String,
      default() {
        return "none";
      },
    },
    autoCropArea: {
      type: Number,
      default() {
        return 0.5;
      },
    },
    background: {
      type: Boolean,
      default() {
        return true;
      },
    },
    rotatable: {
      type: Boolean,
      default() {
        return true;
      },
    },
    changeComponents: {
      type: String,
      default() {
        return "";
      },
    },
    imgSrc: {
      type: String,
      default() {
        return "";
      },
    },
    height: {
      type: Number,
      default() {
        return 500;
      },
    },
  },
  components: {
    VueCropper,
  },
  data() {
    return {};
  },
  watch: {},
  methods: {
    backToImageUploader() {
      if (this.imageName != "") {
        this.$emit("setImageName", "");
      }
      this.$emit("close", "imageUploader");
    },
    cropImage() {
      this.$emit(
        "getCroped",
        this.$refs.cropper.getCroppedCanvas().toDataURL("image/jpeg")
      );
      this.$emit("close", "imageUploader");
    },
  },
  created() {},
};
</script>
<style scoped></style>
